import { createContext, useCallback, useContext, useState } from 'react';
import axios from 'axios';
import { GET_BANNERS_BY_OFFICE_SERVICE } from '../services/bannerService';
import { GET_CATEGORY_IMAGE_MAP_SERVICE } from '../services/categoryService';
import { PROMO_DATA } from '../utils/promos';


const ProductsContext = createContext();

export const ProductsContextProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  // const [products, setProducts, addProductToChartAction] = useState(() => {
  //   // Leer los productos desde localStorage al inicializar
  //   const storedProducts = localStorage.getItem("products");
  //   return storedProducts ? JSON.parse(storedProducts) : [];
  // });

  const [promotions, setPromotions] = useState([]);
  const [advertisements, setAdvertisements] = useState([]);
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [search, setSearch] = useState('');
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [bestSellers, setBestSellers] = useState([])
  const [moreRentability, setMoreRentability] = useState([])
  const [moreInteresting, setMoreInteresting] = useState([])
  const [searchProducts, setSearchProducts] = useState([])
  const [banners, setBanners] = useState({ topBanners: [], mediumBanners: []})
  const [categoryImageMap, setCategoryImageMap] = useState({})

  //  // Método para añadir productos adicionales
  // const addProductAditional = (product) => {
  //   setProducts((prevProducts) => {
  //     // Verificar si el producto ya existe
  //     const exists = prevProducts.some((prod) => prod.product.code === product.code);
  //     if (!exists) {
  //       console.log('NUEVO PROD ADD: ', product);

  //       // Añadir el producto como un nuevo elemento al estado
  //       return [
  //         ...prevProducts,
  //         {
  //           product: { ...product },
  //           ProductType: "ADITIONAL",
  //           amount: 1,
  //           promotionChecked: product.promotions?.length > 0,
  //         },
  //       ];
  //     }
  //     // Si ya existe, no cambiar el estado
  //     return prevProducts;
  //   });
  // };

  const getProducts = useCallback(async (user) => {
    //console.log('usuario logeado3: ', user);
    
    
    const data = JSON.stringify({
      officeId: user.officeId,
      storageId: user.storageId,
      productId: '*.*',
      priceListCode: user.priceListCode,
      clientMobilePhone: user.mobilePhone,
      addressCode: user.addressId
    });
    const cdata = {
      priceId: user.priceListId, // Aquí 'parametro' es la clave y 'valorString' es el valor de tipo string.
      clientCode: user.clientCode, // Código del cliente
      addressId: user.addressId, // DireccionId
    };
    
    
    const config = {
      method: 'post',
      url: process.env.REACT_APP_GET_PRODUCT_URL,
      headers: {
        api_key: process.env.REACT_APP_ECONOMYSA_API_KEY,
        'Content-Type': 'application/json',
      },
      data: cdata,
    };
    
    try {
      console.log("-------PRODUCTOS INI--------");
      const res = await axios(config);
      console.log('prod context: ', res.data.products.length);
      console.log('Products: ', res.data.products);
      //console.log('prod context Canal: ', res.data.products[0]?.saleMin?? '');
      let products = res.data.products;     
      let brands = res.data.brands;
      if (res.data.products.length > 0)
        setProducts(res.data.products);
      const config2 = {
        method: 'post',
        url: process.env.REACT_APP_GET_PROMOTIONS_URL,
        headers: {
          api_key: process.env.REACT_APP_ECONOMYSA_API_KEY,
          'Content-Type': 'application/json',
        },
        data: cdata,
      };
  
      var res2 = await axios(config2);
      res2 = res2.data;//obtengo las promociones desde el back
      console.log("getPromoList: ", res2);
      var promotionsList = res2;
      //recorro las promociones
      for (let i = 0; i < promotionsList.length; i++) 
      {
        const objpromotion = promotionsList[i];//obtengo la promocion
        //console.log("objpromotion: ", objpromotion);
        if (objpromotion.products != undefined)
        {
          //recorre todos los productos afectados por la promocion
          for (let j = 0; j < objpromotion.products.length; j++) {
            const objproduct = objpromotion.products[j];//obtengo el producto afectado
            //console.log("objproduct - Promo: ", objproduct);
            //verifico si el producto de la promocion esta en la lista de productos
            const productIndex = products.findIndex((item) => item.code === objproduct.Code);
            //console.log("objproduct - Promo Count: ", productIndex);
            if (productIndex !== -1) 
            {
              // Verifica si 'promotions' está definido y si no, inicialízalo
              if (!products[productIndex].promotions) {
                products[productIndex].promotions = [];
              }
              // Verificar si el código ya existe en las promociones
              const promoExists = products[productIndex].promotions.some((promo) => promo.code === objpromotion.Code);
              // Agregar la promoción al arreglo 'promotions'
              if (!promoExists) {
                products[productIndex].promotions.push(
                {
                  code: objpromotion.Code,
                  promotion: objpromotion.PromotionName,
                  dateStart: objpromotion.StartDate,
                  dateEnd: objpromotion.EndDate,
                  timeStart: objpromotion.StartDate,
                  timeEnd: objpromotion.EndDate,
                  promoType: objpromotion.PromotionType,
                  StockPerCustomer: objpromotion.StockPerCustomer,
                  StockPerStore: objpromotion.StockPerStore,
                  Code: objpromotion.Code,
                  ApplyToAllProducts: objpromotion.ApplyToAllProducts,
                  Recurrence: objpromotion.Recurrence,
                  DiscountDetail: objpromotion.DiscountDetail,
                  Description : objpromotion.Description,
                  Conditions:  objpromotion.Conditions,
                });
              }
              //products[productIndex].salePrice = products[productIndex].priceDiscount - 10;
              //  console.log("Producto con Promo: ", products[productIndex]);
            }
          }
        }
      }
      //console.log('Products fin: ', products);
      console.log("-------PRODUCTOS FIN--------");
      // for (const element of products)
      //   {   
      //     if (objpromotion.products != undefined)
      //     {
      //       element.dinamicDiscounts = objpromotion.filter(discount => discount.products[0].codeProduct == element.code);
      //       element.dinamicDiscounts = element.dinamicDiscounts.length > 0 ? element.dinamicDiscounts : element.dinamicDiscounts;
      //       for (const element2 of element.dinamicDiscounts) {
      //         console.log("descuento encontrado");          
      //         element2.salePrice = Number(((100 - element2.priceDiscount) * element.salePrice / 100).toFixed(1));
      //         console.log(element2);
      //       }
      //   }
      //   }

      // for (const element of products)
      // {   
      //     const productIndex = products.findIndex((item) => item.code === element.Code);
      //     element.dinamicDiscounts = promotions2.filter(discount => discount.products[0].codeProduct == element.code);
      //     element.dinamicDiscounts = element.dinamicDiscounts.length > 0 ? element.dinamicDiscounts : element.dinamicDiscounts;
      //     for (const element2 of element.dinamicDiscounts) {
      //       console.log("descuento encontrado");          
      //       element2.salePrice = Number(((100 - element2.priceDiscount) * element.salePrice / 100).toFixed(1));
      //       console.log(element2);
      //     }
      // }

          // dispatch({
          // 	type: GET_ALL_PRODUCTS_EXITO,
          // 	payload: {
          // 		products: products,
          // 		promotions: promotions,
          // 		categories: allCategories,
          // 		bestSellerProducts: bestSellerProducts,
          // 		rentabilityProducts: rentabilityProducts,
          // 		interestingProducts: interestingProducts,
          // 		brandsOrdered: brands,
          // 	},
          // });

          localStorage.setItem(
          	"products",
          	JSON.stringify(products)
          );
          // localStorage.setItem(
          // 	"promotions",
          // 	JSON.stringify(promotions)
          // );
          // localStorage.setItem(
          // 	"allCategories",
          // 	JSON.stringify(allCategories)
          // );
          // localStorage.setItem(
          // 	"bestSellerProducts",
          // 	JSON.stringify(bestSellerProducts)
          // );
    
      // ************************
      getBestSeller(products)
      getMoreRentability(products)
      getMoreInteresting(products)
      setProducts(products);
      setBrands(brands)

      return products;
    } catch (error) {
      console.log(error);
      return error;
    }
  }, []);

  const getBanners = async (user) => {
    try {
      const officeId = user.storageId || '0';
      const rpta = await GET_BANNERS_BY_OFFICE_SERVICE(officeId);
      
      if (rpta.status === 200 && rpta.data) {
        const bannerData = Array.isArray(rpta.data) ? rpta.data[0] : rpta.data;
        if (!bannerData) {
          setBanners({ topBanners: [], mediumBanners: [] });
          return;
        }

        const mapBannerItem = (item) => ({
          id: item.Id || item.id,
          imgUrl: item.ImgUrl || item.imgUrl,
          relatedProductsIds: item.RelatedProductsIds || item.relatedProductsIds || [],
          urlRedirect: item.UrlRedirect || item.urlRedirect || ''
        });

        const topBanners = (bannerData.TopBanners || bannerData.topBanners || []).map(mapBannerItem);
        const mediumBanners = (bannerData.MediumBanners || bannerData.mediumBanners || []).map(mapBannerItem);

        setBanners({ topBanners, mediumBanners });
      }
    } catch (error) {
      console.log('Error getBanners:', error);
    }
  }

  const getCategoryImageMap = async () => {
    try {
      const rpta = await GET_CATEGORY_IMAGE_MAP_SERVICE();
      if (rpta.status === 200 && Array.isArray(rpta.data)) {
        const map = {};
        rpta.data.forEach((c) => {
          if (c.CategoryName && c.ImageUrl) {
            map[c.CategoryName.toLowerCase()] = c.ImageUrl;
          }
        });
        setCategoryImageMap(map);
      }
    } catch (error) {
      console.log('Error getCategoryImageMap:', error);
    }
  }

  function getCategories(products, allCategories = []) {
    // eslint-disable-next-line no-debugger
    for (let i = 0; i < products.length; i++) {
      const element = products[i];

      let index = allCategories.findIndex((item) => item.name === element.categoria);
      if (index === -1) {
        allCategories.push({
          name: element.categoria,
          subcategories: [],
        });
        index=allCategories.length-1;
       } 
      if (allCategories[index].subcategories.findIndex((item) => item.name === element.subcategoria) === -1) {
        allCategories[index].subcategories.push({
          name: element.subcategoria,
        });
      }
    }
    setCategories(allCategories);
    return allCategories;
  }

  function getBrands(products, brands = []) {
    for (let i = 0; i < products.length; i++) {
      const element = products[i];

      let index = brands.findIndex((item) => item.name === element.marca);
      if (index === -1) {
        brands.push({
          name: element.marca
        });
      }
    }

    setBrands(brands);
    return brands;
  }

  const getPromotions = async (user) => {
    let promotions = [];
    const cdata2 = {
      priceId: user.priceListId, // Aquí 'parametro' es la clave y 'valorString' es el valor de tipo string.
      clientCode: user.clientCode, // Código del cliente
      addressId: user.addressId, // DireccionId
    };
    const config = {
      method: 'post',
      url: process.env.REACT_APP_GET_PROMOTIONS_URL,
      headers: {
        api_key: process.env.REACT_APP_ECONOMYSA_API_KEY,
        'Content-Type': 'application/json',
      },
      data: cdata2,
    };
    console.log("-------PROMOCIONES INI--------");
    var response = await axios(config);
    response = response.data;      
    console.log("promociones", response);
    console.log("producto-Promociones", products);
    promotions = response;
    // for (let i = 0; i < promotions.length; i++) {
    //   const promotion = promotions[i];
    //   if (promotion.products != undefined)
    //   {
    //     for (let j = 0; j < promotion.products.length; j++) {
    //       const product3 = promotion.products[j];
    //       product3.promotion = [];
    //       //console.log("product3", product3);
    //       const productIndex = products.findIndex((item) => item.code === product3.Code);
    //       console.log("productIndex", productIndex);
    //       if (productIndex !== -1) 
    //       {
    //         if (!products[productIndex].promotions) {
    //           products[productIndex].promotions = [];
    //         }
    //         // Verificar si el código ya existe en las promociones
    //         console.log("Producto sin Promo: ", products[productIndex]);
    //           const promoExists = products[productIndex].promotions.some((promo) => promo.code === product3.Code);
    //           // Agregar la promoción al arreglo 'promotions'
    //           if (!promoExists) {
    //             console.log("Producto promotion code 2: ", promotion.Code);
    //             products[productIndex].promotions.push({
    //               code: promotion.Code,
    //               promotion: promotion.PromotionName,
    //               PromotionDetail : promotion.PromotionName,
    //               dateStart: promotion.StartDate,
    //               dateEnd: promotion.EndDate,
    //               timeStart: promotion.StartDate,
    //               timeEnd: promotion.EndDate,
    //               promoType: promotion.PromotionType,

    //               Recurrence: promotion.Recurrence,
    //             });
    //           }
    //       }
    //       console.log("Producto con Promo: ", products[productIndex]);
    //     }
    //   }
    // }
    setPromotions(promotions)
    console.log("-------PROMOCIONES FIN--------");
      // .catch(function (error) {
      //   // promotions = PROMO_DATA.data;
      //   // for (let i = 0; i < promotions.length; i++) {
      //   //   const promotion = promotions[i];
      //   //   for (let j = 0; j < promotion.products.length; j++) {
      //   //     const product = promotion.products[j];
      //   //     if (products.findIndex((item) => item.codeProduct === product.codeProduct) !== -1) {
      //   //         [products.findIndex((item) => item.codeProduct === product.codeProduct)].promotions.push({
      //   //         code: promotion.code,
      //   //         promotion: promotion.PromotionName,
      //   //         dateStart: promotion.dateStart,
      //   //         dateEnd: promotion.dateEnd,
      //   //         timeStart: promotion.timeStart,
      //   //         timeEnd: promotion.timeEnd,
      //   //         promoType: promotion.promoType,
      //   //       });
      //   //     }
      //   //   }
      //   // }
      //   // setPromotions(promotions)
      //   console.error(error);
      // });
  }
  
  const getAdvertisements = useCallback(async (user) => {
    console.log("-------ANUNCIOS--------");
    let Advertisement = [];
    const cdata2 = {
      priceId: user.priceListId, // Aquí 'parametro' es la clave y 'valorString' es el valor de tipo string.
      clientCode: user.clientCode, // Código del cliente
      addressId: user.addressId, // DireccionId
    };
    const config = {
      method: 'post',
      url: process.env.REACT_APP_GET_ADVERTISEMENT_URL,
      headers: {
        api_key: process.env.REACT_APP_ECONOMYSA_API_KEY,
        'Content-Type': 'application/json',
      },
      data: cdata2,
    };
    console.log("-------ANUNCIOS INI--------");
    var response = await axios(config);
    response = response.data;      
    console.log("ANUNCIOS", response);
    Advertisement = response;
   
    setAdvertisements(Advertisement)
    return Advertisement;
    console.log("-------ANUNCIOS FIN--------");
  }, []);
  
  
  const getCategoriesSearch = (products) => {

    let allCategories = [];

    for (let i = 0; i < products.length; i++) {
      const element = products[i];

      let index = allCategories.findIndex((item) => item.name === element.categoria);
      if (index === -1) {
        allCategories.push({
          name: element.categoria,
          subcategories: [],
        });
      } else {
        if (allCategories[index].subcategories.findIndex((item) => item.name === element.subcategoria) === -1) {
          allCategories[index].subcategories.push({
            name: element.subcategoria,
          });
        }
      }
    }

    return allCategories;
  }
  
  const filterProductsByCategory = (products, categories, category, subcategory) => {
    try {
      // let products = getState().productsCollection.products.slice();
      if (products.length === 0) {
        products = JSON.parse(localStorage.getItem('products')) || '[]';
      }
      // let categories = getState().productsCollection.categories;
      if (categories.length === 0) {
        categories = JSON.parse(localStorage.getItem('allCategories')) || '[]';
      }
      category = category.split('-').join(' ');
      subcategory = subcategory.split('-').join(' ');
      let subCategories = categories[categories.findIndex((item) => item.name.toUpperCase() === category.toUpperCase())].subcategories;
      let subCategoryIndex = subCategories.findIndex((item) => item.name.toUpperCase() === subcategory.toUpperCase());
      let filteredProducts = products.filter((item) => item.categoria.toUpperCase() === category.toUpperCase());
      if (subcategory.toUpperCase() !== 'HOME') {
        filteredProducts = filteredProducts.filter((item) => item.subcategoria.toUpperCase() === subcategory.toUpperCase());
      }
      let maxPrice = filteredProducts.reduce(function (prev, current) {
        return prev.salePrice > current.salePrice ? prev : current;
      }).salePrice;
      let minPrice = filteredProducts.reduce(function (prev, current) {
        return prev.salePrice < current.salePrice ? prev : current;
      }).salePrice;
      // dispatch({
      // 	type: FILTER_PRODUCTS_BY_CATEGORY,
      // 	payload: {
      // 		category: category,
      // 		categories: categories,
      // 		subCategory: subcategory,
      // 		subCategories: subCategories,
      // 		subCategoryIndex: subCategoryIndex,
      // 		filteredProducts: filteredProducts,
      // 		minPrice: minPrice,
      // 		maxPrice: maxPrice,
      // 	},
      // });
      // localStorage.setItem(
      // 	"filteredProducts",
      // 	JSON.stringify(filteredProducts)
      // );
      console.log({filtrado: filteredProducts});
      setFilteredProducts(filteredProducts);
      return {
        category: category,
        categories: categories,
        subCategory: subcategory,
        subCategories: subCategories,
        subCategoryIndex: subCategoryIndex,
        // filteredProducts: filteredProducts,
        minPrice: minPrice,
        maxPrice: maxPrice,
      };
    } catch (error) {
      console.log(error);
    }
  };

  const filterProductsByBrand = (products, categories, brand, subcategory) => {
    try {
      // let products = getState().productsCollection.products.slice();
      if (products.length === 0) {
        products = JSON.parse(localStorage.getItem('products')) || '[]';
      }

      // let categories = getState().productsCollection.categories;

      if (categories.length === 0) {
        categories = JSON.parse(localStorage.getItem('allCategories')) || '[]';
      }

      brand = brand.split('-').join(' ');

      subcategory = subcategory.split('-').join(' ');

      let filteredProducts = products.filter((item) => item.marca.toUpperCase() === brand.toUpperCase());

      let subCategories = [];
      for (let i = 0; i < filteredProducts.length; i++) {
        if (subCategories.filter((item) => item.name === filteredProducts[i].subcategoria).length === 0) {
          subCategories.push({ name: filteredProducts[i].subcategoria });
        }
      }

      let subCategoryIndex = subCategories.findIndex((item) => item.name.toUpperCase() === subcategory.toUpperCase());

      if (subcategory.toUpperCase() !== 'HOME') {
        filteredProducts = filteredProducts.filter((item) => item.subcategoria.toUpperCase() === subcategory.toUpperCase());
      }

      let maxPrice = filteredProducts.reduce(function (prev, current) {
        return prev.salePrice > current.salePrice ? prev : current;
      }).salePrice;
      let minPrice = filteredProducts.reduce(function (prev, current) {
        return prev.salePrice < current.salePrice ? prev : current;
      }).salePrice;

      // dispatch({
      // 	type: FILTER_PRODUCTS_BY_BRAND,
      // 	payload: {
      // 		brand: brand,
      // 		categories: categories,
      // 		subCategory: subcategory,
      // 		subCategories: subCategories,
      // 		subCategoryIndex: subCategoryIndex,
      // 		filteredProducts: filteredProducts,
      // 		minPrice: minPrice,
      // 		maxPrice: maxPrice,
      // 	},
      // });

      // console.log('filterProductsByBrand\nproductosDuck\n')
      // console.log('categories', categories)
      // console.log('subcategory', subcategory)
      // console.log('subCategories', subCategories)
      // console.log('subCategoryIndex', subCategoryIndex)
      // console.log('filteredProducts', filteredProducts)
      // console.log('minPrice', minPrice)
      // console.log('maxPrice', maxPrice)

      // localStorage.setItem(
      // 	"filteredProducts",
      // 	JSON.stringify(filteredProducts)
      // );

      setFilteredProducts(filteredProducts);
      return {
        brand: brand,
        categories: categories,
        subCategory: subcategory,
        subCategories: subCategories,
        subCategoryIndex: subCategoryIndex,
        // filteredProducts: filteredProducts,
        minPrice: minPrice,
        maxPrice: maxPrice,
      };
    } catch (error) {
      console.log(error);
    }
  };

  const getBestSeller = (products) => {
    const newProducts = products
      .filter((item) => item.clasificacion === '1' && item.stockAmount !== 0)
      .sort((a, b) => {
        if (a.numberBestSeller > b.numberBestSeller) return 1;
        if (a.numberBestSeller < b.numberBestSeller) return -1;
        return 0;
      });

    setBestSellers(newProducts)
  };

  const getMoreRentability = (products) => {
    const newProducts = products
      .filter((item) => item.clasificacion === '2' && item.stockAmount !== 0)
      .sort((a, b) => {
        if (a.margin > b.margin) return -1;
        if (a.margin < b.margin) return 1;
        return 0;
      });
      // console.log(JSON.stringify(products));
      // console.log(JSON.stringify(newProducts));
    setMoreRentability(newProducts)
  };

  const getMoreInteresting = (products) => {
    const newProducts = products
      .filter((item) => item.clasificacion === '3' && item.stockAmount !== 0)
      .sort((a, b) => {
        if (a.numberMoreInteresting > b.numberMoreInteresting) return 1;
        if (a.numberMoreInteresting < b.numberMoreInteresting) return -1;
        return 0;
      });

    setMoreInteresting(newProducts)
  };

  return (
    <ProductsContext.Provider
      value={{
        products,
        categories,
        brands,
        search,
        banners,
        promotions,
        advertisements,
        searchProducts,
        bestSellers,
        moreRentability,
        moreInteresting,
        filteredProducts,
        setProducts,
        setBrands,
        setPromotions,
        setAdvertisements,
        getProducts,
        getCategories,
        getPromotions,
        getAdvertisements,
        getBrands,
        filterProductsByCategory,
        setSearch,
        setFilteredProducts,
        setSearchProducts,
        filterProductsByBrand,
        getCategoriesSearch,
        getBestSeller,
        getMoreRentability,
        getMoreInteresting,
        getBanners,
        getCategoryImageMap,
        categoryImageMap,
      }}
    >
      {children}
    </ProductsContext.Provider>
  );
};

export const useProducts = () => {
  return useContext(ProductsContext);
};
